import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import VT01N00 from './../workinstructions/images/VT01N-01.png';
import VT01N01 from './../workinstructions/images/VT01N-createshipment01.png';
import VT01N02 from './../workinstructions/images/VT01N-02.png';
import VT01N03 from './../workinstructions/images/VT01N-03.png';
import VT02N00 from './../workinstructions/images/VT02N-00.png';
import VT01Nremovedelivery01 from './../workinstructions/images/VT01N-removederlivery01.png';

class Shipment extends React.Component {
	async componentDidMount() {
    document.title = "Create/Edit Shipment";    
  }
	render() {
		return (
			<div>
		{/*				<ol className="breadcrumb float-xl-end">
					<li className="breadcrumb-item active">Cookie Acceptance Banner</li>
				</ol>
				<h1 className="page-header">Cookie Acceptance Banner <small>header small text goes here...</small></h1>   */}
				<Panel>
					<PanelHeader>Shipment VT01N, VT02N</PanelHeader>
					<PanelBody>
					<h2>Createment of shipment</h2>
						<p>
							start VT01N =&gt; fill in FI28 at TransportShippingPt =&gt; at "Shipment type" select = Tracking  Shipment =&gt; press F6
							<p> <img src={VT01N00} alt="VT01N create shipment" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							<p> <img src={VT01N01} alt="VT01N create shipment" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							<p> <img src={VT01N02} alt="VT01N create shipment" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							Go to tab "Select Single Values " and fill in the delivery-numbers =&gt; press enter after finished
							<p> <img src={VT01N03} alt="VT01N create shipment" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
						</p>
					<h2>Change shipment</h2>
						<p>
						
						</p>
						<h2>Xvak IR SCRAP</h2>
						<p>
							=&gt; start LT12 =&gt; enter =&gt; click on confirm immediately =&gt; save
						</p>
						<h2>Xvak Scrums Sending back to Customer</h2>
						<p>						
							use YSD_Pack =&gt; paste delivery-nr here =&gt; enter =&gt; F8 =&gt; go to tab TEXT =&gt; in header note 3 type SCRAP<br /> =&gt;
							go to PACK (shift F6) =&gt;  Go to tab single entry : fill 1 in "HU Identification  . This is the amount of the package you want to use for shipping =&gt; At HU Identification 2 =&gt; 
							pack materials : fill in Nokia box barcode =&gt; enter <br />
							=&gt; scan barcode of item 2X. Ga naar Pack HUs : enter weight in Total Weight =&gt; save =&gt; Pre-PGI.<br /><br />							
							Use YSDVT70 to printout shipping and summery papers and address-label =&gt;  remove (shipmentnr en Fi28) click on delivery =&gt; F8 =&gt; select all (F5) =&gt; Shift F2.<br />
							One version of shipping-paper will be kept as archive and give the account-team.<br /><br />
						</p>
						<h2>OutBound IR</h2>
						<p>
							Start VT01N  =&gt; fill in FI28 at TransportShippingPt =&gt; select at shipment type = Return trckg ship =&gt; enter =&gt; F6 at type of deliveries =&gt; click op import from text file (Shift +F11) <br />
							=&gt; browse naar C-drive =&gt; users=&gt; user =&gt; desktop =&gt; select most recent RFID-files =&gt; F8 =&gt; F8 =&gt; pack (Shift + F9) =&gt; fill or scan the code of outerbox, packing material <br />
							=&gt; select all deliveries =&gt; select handling unit =&gt; click om pack =&gt; fill in weight =&gt; F3 =&gt; save <br />
							Start VT02N (change shipment) =&gt; enter =&gt; at Fwd Agen : 397003 =&gt; click on planning =&gt; click on shipment completion =&gt; save<br />
							For printing out shipment-papers =&gt; Start YSDVT70 =&gt; remove delivery & shipping point =&gt; click on “shipment”=&gt; F8 =&gt; F5 =&gt; shift +F2<br />
							Use OTM to create AWB<br />
							If you want to ship outside SAP, then crete OTM from scratch. select always economic<br />
							start VT02N =&gt; at external ID1 =&gt; scan AWB-nr =&gt; Go to texts =&gt; header note 3 =&gt; scan AWB =&gt; save
						</p>
						<h2>OutBound common</h2>
						<p>
							Start YSD_PACK =&gt; fill in outbound-delivery-nr =&gt; go to pack (this is amount of package you will use) 1 =&gt; at HU..fill in the code for outerbox<br />
							Single entry Scan the 2D-code in inputfiled 2D barcode =&gt; Go to "Pack" and fill in weight or modify volume<br />
							after inbooking =&gt; save =&gt; pre-pgi <br />
							If needed rfid-labels printout and stick on the items<br />
							Use LT24 to confirm the items, relabel the items with RFID-labels<br />
							Start YSD_PACK =&gt; type in deliverynr =&gt; go to package =&gt; single entry etc… =&gt; scan material & sn =&gt; PGI or Pre-PGI <br />
							start YSDVT70 =&gt; remove shippingpoint<br />
							For printing orders from Italy =&gt; go to extra’s delivery output =&gt; header =&gt; select ZDN7 =&gt; further data =&gt; select immediately =&gt; go back =&gt; save =&gt; print =&gt; 2 =&gt; F8 select second process (shift +F5)
						</p>
						<h2>RFID process via SAP Printing</h2>
						<p>
							Faulty stock shipment creation =&gt; SAP Packing =&gt; select vendor =&gt; fill in SAP delivery =&gt; scan SNs =&gt; close shipment after done =&gt; 
							start RFI-script-room.
						</p>
						<h2>Packing delivery out of shipment</h2>
						<p>
							VT02N =&gt; select on planning & shipment completion =&gt; go to pack=&gt; pack HUs =&gt; click on empty-icon to unpack =&gt; click on delete-icon to  delete package<br />
							=&gt; go to deliveries =&gt; delete transport =&gt; VL09
						</p>
						<h2>Delete transport/shipment</h2>
						<p>
							Use VL09 =&gt; fill in shipment-nr =&gt; click on delete-icon
						</p>
					</PanelBody>
						<footer style={{ marginTop: '2rem', padding: '1rem 0', borderTop: '1px solid #ddd' }}>
						  <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
						    &copy; 2025 by TQT Tong. All rights reserved.
						  </p>
						</footer>
								
				</Panel>
		
			</div>
		)
	}
}

export default Shipment;
